export enum StrategyRequestLegPriceType{
    Undefined = 'Undefined',
    Market ='Market',
    Limited = 'Limited',
    StopLoss = 'StopLoss',
    StopLimited = 'StopLimited',
    MarketWithLeftOverAsLimit = 'MarketWithLeftOverAsLimit'
}